import {getCurrentTime} from '../getCurrentTime';

type DayOfWeek = 1 | 2 | 3 | 4 | 5 | 6 | 0;

export function getWeekDay(): DayOfWeek {
  const currentTime: UnixTimeStamp = getCurrentTime();
  return new Date(currentTime).getDay() as DayOfWeek;
}
